import React from 'react'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import cx from 'classnames'
import dayjs from 'dayjs'
import InfoToolTipIcon from './InfoToolTipIcon'
import { includes, range } from 'libraries/lodash'
import Icon from 'components/shared/Icon'
import { LONG_DAY_FORMAT, SHORT_DAY_FORMAT } from 'constants/locale'

const SelectEmailDays = ({ caEmailDays, caEmails, handleChange }) => (
  <Grid container className='pv6 pl5 pr5 pr0-t' spacing={1}>
    <Grid item xs={12} sm={7} md={6}>
      <EmailDaysTitle />
    </Grid>
    <Grid item xs={12} sm={5} md={6} style={{ backgroundColor: 'unset' }}>
      <Grid container spacing={1}>
        {range(1, 6).map((weekDayNumber, index) => (
          <CaEmailDayCheckBox
            key={index}
            id={`caEmailDays${weekDayNumber}`}
            checked={caEmails && includes(caEmailDays, weekDayNumber)}
            {...{ weekDayNumber, handleChange }}
          />
        ))}
      </Grid>
    </Grid>
  </Grid>
)

export default SelectEmailDays

const EmailDaysTitle = () => {
  const tootTipTitle = 'These options allow you to select which days of the week you would like to receive Current Awareness emails. ' +
    'If you select just one day, you will receive all daily articles for the whole week in one email.'

  return (
    <div className='flex items-center'>
      <div>
        <InfoToolTipIcon title={tootTipTitle} />
      </div>
      <span>Chosen days of week to receive emails</span>
    </div>
  )
}

const CaEmailDayCheckBox = ({ handleChange, checked, id, weekDayNumber }) => {
  const iconName = checked ? 'icon-checkbox-marked' : 'icon-checkbox-blank-thin-outline'

  return (
    <Grid item xs={12} sm={12} md={12} lg={2} style={{ backgroundColor: 'unset' }}>
      <input
        className='dn' type='checkbox' {...{ checked, id }}
        onChange={() => handleChange('caEmailDays', weekDayNumber)}
      />
      <label
        htmlFor={id}
        className={cx(
          'flex items-center lighter mb0 pointer account-input-label',
          { 'account-input-checked': checked }
        )}
      >
        <Icon className={cx('w7 mr2')} name={iconName} />
        <span className={cx({ teal: checked })}>
          <Hidden mdDown>
            {dayjs().day(weekDayNumber).format(SHORT_DAY_FORMAT)}
          </Hidden>
          <Hidden lgUp>
            {dayjs().day(weekDayNumber).format(LONG_DAY_FORMAT)}
          </Hidden>
        </span>
      </label>
    </Grid>
  )
}
